// ----------------------------------------------------------------------------
// Product Gallery Module: Thumbnail Counter
// ----------------------------------------------------------------------------
// Keeps the "position indicator" (e.g. 7/12) below the thumbnail slider in sync
// with the active gallery slide. The indicator markup is only rendered by
// `product-gallery.liquid` when the gallery has more images than a full
// thumbnail column can show, so this module no-ops when it isn't present.
// ----------------------------------------------------------------------------
// Event Listeners:
// - 'productForm:gallery:featureSlider:ready'   → Sets the initial position.
// - 'productForm:gallery:featureSlider:changed' → Updates on slide change.
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import iamotaEventHandler from 'scripts/helpers/iamota-event-handler';

// -------------------------------------
// Thumbnail Counter Class
// -------------------------------------

class ThumbnailCounter {
  constructor(iamProductGallery) {
    // Reference to parent
    this.iamProductGallery = iamProductGallery;

    // Cache the counter element (absent when at/under the render threshold)
    this.counter = iamProductGallery.querySelector('[data-thumbnails-counter]');
    if (!this.counter) {
      return;
    }
    this.currentEl = this.counter.querySelector('[data-thumbnails-counter-current]');

    // Register Events
    iamotaEventHandler.subscribe('productForm:gallery:featureSlider:ready', _ref => {
      var {
        swiper
      } = _ref;
      return this.update(swiper);
    }, {
      context: iamProductGallery,
      source: "thumbnailCounter.js"
    });
    iamotaEventHandler.subscribe('productForm:gallery:featureSlider:changed', _ref2 => {
      var {
        swiper
      } = _ref2;
      return this.update(swiper);
    }, {
      context: iamProductGallery,
      source: "thumbnailCounter.js"
    });
  }

  /**
   * Update the displayed position to the active slide (1-based)
   */
  update(swiper) {
    if (!this.currentEl || !swiper) {
      return;
    }
    this.currentEl.textContent = swiper.activeIndex + 1;
  }
}
var thumbnailCounters = [];
iamotaEventHandler.subscribe('productForm:gallery:init', _ref3 => {
  var {
    iamProductGallery
  } = _ref3;
  thumbnailCounters.push(new ThumbnailCounter(iamProductGallery));
}, {
  source: "thumbnailCounter.js"
});
export default thumbnailCounters;